import { FC, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTE_PATHS } from "../../../routes";
import { useTermsModalContext } from "../../../context/TermsModalContext";

/**
 * While `blocked`, collapses every route onto the dashboard.
 *
 * The blocking modal already covers the page, so this is not what stops the
 * vendor — it stops the page *behind* the scrim from mounting and firing a
 * screenful of requests that the server guard will refuse anyway. It also means
 * a deep link opened from an email lands somewhere coherent once they accept.
 */
const TermsBlockedRedirect: FC = () => {
	const { showBlockingModal } = useTermsModalContext();
	const navigate = useNavigate();
	const { pathname } = useLocation();

	useEffect(() => {
		if (showBlockingModal && pathname !== ROUTE_PATHS.DASHBOARD) {
			navigate(ROUTE_PATHS.DASHBOARD, { replace: true });
		}
	}, [showBlockingModal, pathname, navigate]);

	return null;
};

export default TermsBlockedRedirect;
